export const AvatarDummyBuilder = (character: string, width: number = 100, height: number = 100) => {
  return `https://dummyimage.com/${width}x${height}/01194b/fafbfc?text=${character.toLocaleUpperCase()}`;
};
